import startSitePage from 'navigation/startSitePage';
import { startSiteSession } from 'session/siteSession';
import { bindFormSafeguards } from 'pages/formSafeguards';
import { bindLocaleLinks } from 'navigation/localeLinks';
import { bindLocaleRequests } from 'navigation/localeRequests';
import { bindDebugRequests } from 'debug/debugRequests';

// Every full page load: the page area first, then the site session (store and,
// logged in, the socket). A page entry's activate says what the session's
// first startup and socket handshake need (the netplay page claims its socket
// filter and startup sections), so the session connects once with them.
$(function() {
	// Before anything requests: the debug panel lists every request's queries.
	bindDebugRequests(window, document);
	bindFormSafeguards(document);
	bindLocaleLinks(document);
	bindLocaleRequests($, document);
	const startSession = () => startSiteSession(window);
	startSitePage(document).then(startSession, (error) => {
		console.error(error);
		startSession();
	});
});
